import type { TrabajoDeLaAprobacion } from "./api";

/**
 * Lo que lleva dentro una aprobación: cada trabajo, y el antes → después.
 *
 * Va en la tarjeta de «Te toca a ti» y en la del chat, que son las dos puertas
 * por las que se decide. Una aprobación agrupada —seis títulos, o un cambio de
 * texto y un lote del mismo turno— se enseña entera: el trabajo que decide
 * puede no ser el primero.
 *
 * Una página cuyo «ahora» no se leyó lo dice —«sin leer»— en vez de dejar la
 * celda en blanco: aprobar sin saber qué había es aprobar a ciegas, y eso tiene
 * que verse antes de pulsar, no después.
 */
export function DetalleDeTrabajos({ trabajos }: { trabajos: TrabajoDeLaAprobacion[] }) {
  if (trabajos.length === 0) return null;
  return (
    <div className="detalle-trabajos">
      {trabajos.map((t, i) => (
        <div key={`${t.capacidad}-${i}`} className="trabajo">
          {trabajos.length > 1 && (
            <div className="que">
              {i + 1}. {t.que}
            </div>
          )}
          {t.cambio && (
            <p className="cambio">
              «{t.cambio.antes}» → «{t.cambio.despues}»
            </p>
          )}
          {t.lote.length > 0 && (
            <div className="envoltura">
              <table>
                <thead>
                  <tr>
                    <th scope="col">Página</th>
                    <th scope="col">Ahora</th>
                    <th scope="col">Pasará a</th>
                  </tr>
                </thead>
                <tbody>
                  {t.lote.map((f) => (
                    <tr key={f.pagina}>
                      <td>{f.pagina}</td>
                      <td className={f.ahora ? undefined : "no-se-sabe"}>{f.ahora ?? "sin leer"}</td>
                      <td>{f.pasaraA}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      ))}
    </div>
  );
}
